import { Injectable } from '@angular/core';
import { EnvConfigurationService } from './envconf.service';
import { CustomAuthService } from './auth/auth.service';
import { AppLaunchAction } from '../enums/app-launch-action';

@Injectable({ providedIn: 'root' })
export class AppLauncherService {
  constructor(private readonly authService: CustomAuthService) {}

  // Redireciona para o app externo via SSO, repassando o authToken; localizado pelo trigram do app em APP_URLS.
  open(trigram: string, target: '_blank' | '_self' = '_blank', action?: AppLaunchAction): void {
    const baseUrl = EnvConfigurationService.configuration.APP_URLS[trigram];
    if (!baseUrl) {
      throw new Error(`App URL não configurada para trigram "${trigram}"`);
    }

    const authToken = this.authService.getAuthToken();
    const actionParam = action ? `&action=${encodeURIComponent(action)}` : '';
    const url = `${baseUrl}/sso-redirect?token=${encodeURIComponent(authToken)}${actionParam}`;
    window.open(url, target);
  }

  // App sem base URL no ambiente atual = integração ainda não disponível.
  hasUrl(trigram: string): boolean {
    return !!EnvConfigurationService.configuration.APP_URLS[trigram];
  }
}
